import { OnDeckLogo } from '@odmonorepo/core-components';
import { useApplication } from 'merchant-api/unified';
import { Link } from '@tanstack/react-router';
import { Stack } from 'react-bootstrap';
import PartnerLogo, { isStrategicPartner } from './PartnerLogo/PartnerLogo';

export function CobrandedHeader() {
  const { applicationData } = useApplication();
  const referralSource = applicationData?.metadata?.referralSource;

  const strategicPartner = isStrategicPartner(referralSource)  
    ? referralSource
    : undefined;

  return (
    <Stack direction="horizontal">
      <Link to="/">
        <OnDeckLogo width="150px" className="mb-4" />
      </Link>
      {strategicPartner &&
        <div className="d-sm-block ps-3 d-sm-flex text-center mb-3">
          <div className="fs-7 p-0 pe-sm-3 pt-sm-1">in partnership with</div>
          <PartnerLogo partner={strategicPartner} />
        </div>
      }
    </Stack>
  );
}

export default CobrandedHeader;
